import { Flex } from '@payflip/ui/v2';
import { PropsWithChildren } from 'react';
import { AppBanner } from './app-overlays/app-banner';

export function AppOverlaySection({
  children
}: PropsWithChildren): JSX.Element {
  return (
    <Flex flexDir="column" w="full" h="full">
      <AppBanner />
      {children}
    </Flex>
  );
}
